import "../../../../assets/userTheme/assets/css/theme.css";
import "../../../../assets/userTheme/assets/vendor/fontawesome/css/all.min.css";
import "../../../../assets/userTheme/assets/vendor/slick-carousel/slick/slick.css";
import imgLogo from "../../../../assets/uploads/logo.png"
import useAuth from "../../../../hooks/useAuth";
import React from "react";
import * as PropTypes from "prop-types";
import PhoneMenu from "../PhoneMenu"
import Dialog from "@mui/material/Dialog";
import { IS_BETA } from "../../../../utils/constants";

export default function Header() {
    const { logout, auth } = useAuth()
    const organizationName = auth ? auth?.primaryUser?.organizationName : null
    const organizationLogo = auth ? auth?.primaryUser?.organizationLogo : null

    const [open, setOpen] = React.useState(false)
    const handleClose = () => {
        setOpen(false)
    }

    const handleOpen = () => {
        setOpen(true)
    }

    return (
        <div>
            <header id="header" className="header header-front">

                <div className="header-section">

                    <div id="logoAndNav" className="container">
                        <nav className="js-mega-menu navbar navbar-expand-lg">
                            <div className="navbar-brand" style={{ display: 'flex', alignItems: 'center' }}>
                                <div className="navbar-body header-abs-top-inner">
                                    <ul className="navbar-nav">

                                        <li className="navbar-nav-last-item">
                                            {organizationLogo ? (
                                                <img src={organizationLogo} alt={organizationName} style={{ maxHeight: 35, objectFit: 'contain' }} />
                                            ) : (
                                                <span style={{
                                                    display: 'inline-block',
                                                    background: '#f5f5f5',
                                                    color: '#333',
                                                    borderRadius: '8px',
                                                    padding: '4px 12px',
                                                    fontWeight: 600,
                                                    fontSize: '1rem',
                                                    letterSpacing: 0.5,
                                                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                                                    border: '1.5px solid #d1d5db'
                                                }}>{organizationName}</span>
                                            )}
                                        </li>
                                    </ul>
                                </div>

                                {IS_BETA && (
                                    <span style={{
                                        display: 'inline-block',
                                        background: '#ff1744',
                                        color: 'white',
                                        borderRadius: '12px',
                                        padding: '1px 10px',
                                        fontSize: '0.75rem',
                                        fontWeight: 700,
                                        marginLeft: 8,
                                        letterSpacing: 1,
                                        textTransform: 'uppercase',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                    }}>
                                        BETA
                                    </span>
                                )}
                            </div>

                            <button
                                type="button"
                                className="navbar-toggler btn btn-icon btn-sm rounded-circle"
                                onClick={handleOpen}
                            >
                                <span className="navbar-toggler-default">
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 18 18"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z"
                                        />
                                    </svg>
                                </span>
                                <span className="navbar-toggler-toggled">
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 18 18"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"
                                        />
                                    </svg>
                                </span>
                            </button>

    

                        </nav>
                    </div>
                </div>
            </header>

            <Dialog fullScreen open={open} onClose={handleClose}>
                <PhoneMenu handleClose={handleClose} />
            </Dialog>

        </div>
    )
}
